import React, { useState } from "react";

import { withRouter } from "react-router";
import loadContent from "core-module/hoc/loadContent";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Wizard from "common/components/Wizard/Wizard.jsx";
import Card from "common/components/Card/Card.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import Icon from "@material-ui/core/Icon";

import SweetAlert from "react-bootstrap-sweetalert";
import * as api from "core-module/services/api";
import { addNewID } from "core-module/services/ids/actions";
import store from "store";
import withStyles from "@material-ui/core/styles/withStyles";
import PackageSpeedDisplay from "./PackageSpeedDisplay.jsx";

import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle";
const importedStyle = dashboardStyle;
const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center",
  },
  offerText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center",
    color: "red",
  },
  inputAdornmentIcon: {
    color: "#555",
  },
  inputAdornment: {
    position: "relative",
  },
  ...buttonStyle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  stats: importedStyle.stats,
  cardIconTitle: importedStyle.cardIconTitle,
  cardDescription: {
    display: "flex",
    flexDirection: "column",
  },
  marginTop30: {
    marginTop: "30px",
  },
  ...pricingPageStyle,
  packageContainer: {
    alignSelf: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "15px",
    padding: "10px",
  },
  arrowIconDiv: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  arrowIcon: {
    fontSize: "50px",
  },
};

class Step0 extends React.Component {
  sendState() {
    return this.state;
  }
  isValidated() {
    return true;
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12}>
          <h3 className={classes.infoText}>Notice:</h3>
          {this.props.allStates.messages.map((element) => (
            <h4 className={classes.infoText}>{element}</h4>
          ))}
        </GridItem>
      </GridContainer>
    );
  }
}

class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offeractive: false,
      offercode: null,
      offertext: null,
    };
  }

  componentDidMount() {
    const upgradepromojson = window.localStorage.getItem(
      `upgradepromo${this.props.allStates.userid}`
    );

    if (upgradepromojson) {
      let upgradepromo = JSON.parse(upgradepromojson);
      if (Date.now() > upgradepromo.expires * 1000) {
        //Expired
        window.localStorage.removeItem("upgradepromo");
      } else {
        this.setState({
          offeractive: true,
          offercode: upgradepromo.offercode,
          offertext: upgradepromo.upgradetext,
        });
      }
    }
  }

  sendState() {
    return this.state;
  }
  isValidated() {
    return true;
  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12}>
          {this.state.offeractive ? (
            <>
              <h4 className={classes.offerText}>
                Active offer:
                <br />
                {this.state.offertext}
              </h4>
              <br />
            </>
          ) : null}
          <h4 className={classes.infoText}>
            If you choose to proceed, your speed, traffic cap and monthly fee
            will change as follows:
          </h4>
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={10}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={5}>
              <Card pricing>
                <CardBody pricing className={classes.packageContainer}>
                  <div>
                    <h6 className={classes.cardCategory}>
                      {this.props.allStates.currentPackageInfo.description}
                    </h6>
                    {/^9+$/.test(
                      this.props.allStates.currentPackageInfo.cap
                    ) ? (
                      <h3 key="unlimitedcurrent">Unlimited</h3>
                    ) : (
                      <h3 key="limitedcurrent">
                        {this.props.allStates.currentPackageInfo.cap}
                        <small> GB</small>
                        {this.props.allStates.extraLoyaltyGb > 0 ? (
                          <small key="addedExtraLoyalty">
                            <br />
                            (+ your {this.props.allStates.extraLoyaltyGb}{" "}
                            loyalty GB)
                          </small>
                        ) : null}
                      </h3>
                    )}
                    <PackageSpeedDisplay
                      packageInfo={this.props.allStates.currentPackageInfo}
                      className={classes.cardDescription}
                    />
                    <h3
                      className={`${classes.cardTitle} ${classes.marginTop30}`}
                    >
                      $ {this.props.allStates.currentPackageInfo.monthly_fee} /
                      month
                    </h3>
                    <br />
                  </div>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={1}>
              <div className={classes.arrowIconDiv}>
                <Icon className={classes.arrowIcon}>keyboard_arrow_right</Icon>
              </div>
            </GridItem>
            <GridItem xs={12} sm={5}>
              <Card pricing>
                <CardBody pricing className={classes.packageContainer}>
                  <div>
                    <h6 className={classes.cardCategory}>
                      {this.props.allStates.selectedPackageInfo.description}
                    </h6>
                    {/^9+$/.test(
                      this.props.allStates.selectedPackageInfo.cap
                    ) ? (
                      <h3 key="unlimitednext">Unlimited</h3>
                    ) : (
                      <h3 key="limitednext">
                        {this.props.allStates.selectedPackageInfo.cap}
                        <small> GB</small>
                        {this.props.allStates.extraLoyaltyGb > 0 ? (
                          <small key="addedExtraLoyalty">
                            <br />
                            (+ your {this.props.allStates.extraLoyaltyGb}{" "}
                            loyalty GB)
                          </small>
                        ) : null}
                      </h3>
                    )}
                    <PackageSpeedDisplay
                      packageInfo={this.props.allStates.selectedPackageInfo}
                      className={classes.cardDescription}
                    />
                    <h3
                      className={`${classes.cardTitle} ${classes.marginTop30}`}
                    >
                      $ {this.props.allStates.selectedPackageInfo.monthly_fee} /
                      month
                    </h3>
                    <br />
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem xs={12} sm={12}>
          <h4 className={classes.infoText}>
            This change will take effect immediately. As our billing is
            prorated, you will see an adjustment for the remainder of the
            current and upcoming period. You can upgrade your package at any
            time. You can also downgrade, however, you can't do so within 30
            days of making a change to your plan.
          </h4>
        </GridItem>
      </GridContainer>
    );
  }
}

const UpgradeWizardStep0 = withStyles(style)(Step0);
const UpgradeWizardStep1 = withStyles(style)(Step1);

const UpgradeWizard = (props) => {
  const [alert, setAlert] = useState(null);

  const handleUpgrade = async () => {
    const handleConfirm = async () => {
      setAlert(
        <SweetAlert
          info
          style={{
            display: "block",
            top: "5%",
            maxWidth: "90%",
            marginTop: "1%",
          }}
          title="Applying changes"
          showConfirm={false}
          onConfirm={() => null}
        >
          {"Please wait while we apply this changes"}
        </SweetAlert>
      );

      const upgradePayload = { packageid: props.getData("id") };
      const upgradepromojson = window.localStorage.getItem(
        `upgradepromo${props.ids.user}`
      );
      if (upgradepromojson) {
        let upgradepromo = JSON.parse(upgradepromojson);
        if (Date.now() > upgradepromo.expires * 1000) {
          //Expired
          window.localStorage.removeItem("upgradepromo");
        } else {
          upgradePayload.offercode = upgradepromo.offercode;
        }
      }

      const upgraderes = await api.postNload(
        `user.${props.ids.user}/packageupgrade.${props.getData("bpid")}`,
        upgradePayload,
        0,
        `user.${props.ids.user}/currentbroadband`,
        `user.${props.ids.user}/broadbandtraffic`,
        `user.${props.ids.user}/upgradable`
      );

      if (upgraderes.success) {
        if (window.localStorage.getItem(`upgradepromo${props.ids.user}`)) {
          window.localStorage.removeItem("upgradepromo");
        }
        setTimeout(() => {
          setAlert(
            <SweetAlert
              success
              style={{
                display: "block",
                top: "5%",
                maxWidth: "90%",
                marginTop: "1%",
              }}
              title="Success"
              showConfirm={false}
              onConfirm={() => null}
            >
              {"Package upgraded!"}
            </SweetAlert>
          );
          setTimeout(() => {
            setAlert(null);

            props.history.push(props.location.pathname, {});
            store.dispatch(addNewID("user", ""));
            store.dispatch(addNewID("user", props.ids.user));
          }, 2000);
        }, 4000);
      } else {
        function onFailUpgrade() {
          setAlert(null);
          if (upgraderes.message === "Invalid offer") {
            window.localStorage.removeItem("upgradepromo");
          }
          window.location.reload();
        }
        setAlert(
          <SweetAlert
            error
            style={{
              display: "block",
              top: "5%",
              maxWidth: "90%",
              marginTop: "1%",
            }}
            title="Upgrade Failed"
            showConfirm={true}
            onConfirm={onFailUpgrade}
            confirmBtnCssClass={
              props.classes.button + " " + props.classes.success
            }
          >
            {upgraderes.message}
          </SweetAlert>
        );
      }
    };

    setAlert(
      <SweetAlert
        info
        style={{
          display: "block",
          top: "5%",
          maxWidth: "90%",
          marginTop: "1%",
        }}
        title="Confirmation"
        onConfirm={handleConfirm}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={props.classes.button + " " + props.classes.success}
        cancelBtnCssClass={props.classes.button + " " + props.classes.warning}
        confirmBtnText="Confirm"
        cancelBtnText="Cancel"
        showCancel
      >
        <h4>
          You have chosen to upgrade to Package{" "}
          {props.selectedPackageInfo.description + " "} Data cap:{" "}
          {/^9+$/.test(props.selectedPackageInfo.cap) ? (
            "Unlimited; "
          ) : (
            <span key="notlimitedconfirm">
              {props.selectedPackageInfo.cap}
              {" GB "}{" "}
              {props.extraLoyaltyGb > 0
                ? " + your " + props.extraLoyaltyGb + " loyalty GB"
                : null}{" "}
              ;
            </span>
          )}{" "}
          <PackageSpeedDisplay
            packageInfo={props.selectedPackageInfo}
            component="span"
            suffix="; "
          />
          Monthly fee: {"$ " + props.selectedPackageInfo.monthly_fee};
          <br />
          By clicking "confirm", these changes will take place on your account.{" "}
        </h4>
      </SweetAlert>
    );
  };

  let wizardSteps = [];

  if (props.getData("messages").length > 0) {
    wizardSteps.push({
      stepName: "Check Out",
      stepComponent: UpgradeWizardStep0,
      stepId: "checkout1",
    });
  }
  wizardSteps.push({
    stepName: "Summary",
    stepComponent: UpgradeWizardStep1,
    stepId: "summary1",
  });

  return (
    <div>
      {alert}
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12} lg={10} xl={8}>
          <Wizard
            color="primary"
            steps={wizardSteps}
            title="Upgrade Wizard"
            subtitle=""
            finishButtonClick={handleUpgrade}
            cancelButtonClick={props.onFinishWizard}
            allStates={{
              messages: props.getData("messages"),
              selectedPackageInfo: props.selectedPackageInfo,
              currentPackageInfo: props.currentPackageInfo,
              extraLoyaltyGb: props.extraLoyaltyGb,
              userid: props.ids.user,
            }}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(style)(
  withRouter(loadContent("user.session/upgradewizard.props", UpgradeWizard))
);
